import { useForm } from 'react-hook-form'
import { FormTemplate, FormTextField, tokens } from 'ComponentLibrary'
import { Mandator } from 'ComponentLibrary/src/molecules/MandatorList/types'
import { Box } from '@mui/material'

type MandatorFormProps = {
    onCancelCallback: () => void
    onSubmitCallback: (data: Mandator) => void
    mandator?: Mandator
    labels: MandatorFormLabels
}

export type MandatorFormLabels = {
    name: string
    street: string
    houseNumber: string
    zip: string
    city: string
    country: string
}

export function MandatorForm({ onCancelCallback, onSubmitCallback, mandator, labels }: MandatorFormProps) {
    const {
        control,
        handleSubmit,
        formState: { errors, isDirty },
        reset,
    } = useForm<Mandator>({
        defaultValues: {
            name: mandator?.name,
            street: mandator?.street,
            house_number: mandator?.house_number,
            zip: mandator?.zip,
            city: mandator?.city,
            country: mandator?.country,
        },
    })

    const onSubmit = handleSubmit((mandator) => {
        mandator.name && onSubmitCallback(mandator)
    })

    const onCancel = () => {
        reset()
        onCancelCallback()
    }

    return (
        <Box marginBottom={tokens.SizingSpacing300}>
            <FormTemplate onSubmit={onSubmit} onCancel={onCancel} isFormDirty={isDirty} dense>
                <FormTextField control={control} fieldName="name" errors={errors} label={labels.name} xs={12} required />
                <FormTextField control={control} fieldName="street" errors={errors} label={labels.street} xs={7} />
                <FormTextField control={control} fieldName="house_number" errors={errors} label={labels.houseNumber} xs={5} />
                <FormTextField control={control} fieldName="zip" errors={errors} label={labels.zip} xs={5} />
                <FormTextField control={control} fieldName="city" errors={errors} label={labels.city} xs={7} />
                <FormTextField control={control} fieldName="country" errors={errors} label={labels.country} xs={12} />
            </FormTemplate>
        </Box>
    )
}
